import React, { useState, Suspense, lazy } from 'react';
import CustomNavbar from '../../../../components/navbar';
import Sidebar from '../../../../components/sidebar';
import MainContent from '../../../../components/mainContent';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Tab from 'react-bootstrap/Tab';
const Tipos = lazy(() => import('../Formularios/tipos'));
const CaracteristicaEcommerce = lazy(() => import('../Formularios/caracteristicaEcommerce'));
const ProducFormList = lazy(() => import('../Formularios/producFormList'));
const FormularioModelo = lazy(() => import('../Formularios/modelo'));
const CadastrosIndexEcommerce = () => {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [key, setKey] = useState('produto');
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };


    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <Sidebar isOpen={isSidebarOpen} />
            {/* Área de conteúdo */}
            <div className={`main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                {/* Navbar */}
                <CustomNavbar toggleSidebar={toggleSidebar} />
                {/* Conteúdo principal */}
                <MainContent>
                    <Container>
                        <Row>
                            <h2 className='text-center titulo-pagina'> <i style={{ color: '#ff7a00' }} class="fa-solid fa-tag"></i> Cadastro de Produtos</h2>
                            <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                                <div className='nav-avaliacao'>
                                    <Navbar expand="lg">
                                        <Nav className="mr-auto">
                                            <Nav.Link eventKey="tipos" onClick={() => setKey('tipos')}><i className="fas fa-filter"></i>Tipos</Nav.Link>
                                            <Nav.Link eventKey="caracteristicas" onClick={() => setKey('caracteristicas')}><i className="fas fa-sliders-h"></i> Características</Nav.Link>
                                            <Nav.Link eventKey="modelo" onClick={() => setKey('modelo')}> <i className="fas fa-puzzle-piece"></i> Modelos</Nav.Link>
                                            <Nav.Link eventKey="produto" onClick={() => setKey('produto')}><i class="fa-solid fa-mobile-screen-button"></i>  Aparelhos</Nav.Link>
                                        </Nav>
                                    </Navbar>
                                </div>
                            </Tab.Container>
                            <Tab.Content>
                                <Tab.Pane eventKey="tipos" active={key === 'tipos'}>
                                    <Suspense fallback={<div>Carregando...</div>}>
                                        {key === 'tipos' && <Tipos />}
                                    </Suspense>
                                </Tab.Pane>
                                <Tab.Pane eventKey="caracteristicas" active={key === 'caracteristicas'}>
                                    <Suspense fallback={<div>Carregando...</div>}>
                                        {key === 'caracteristicas' && <CaracteristicaEcommerce />}
                                    </Suspense>
                                </Tab.Pane>
                                <Tab.Pane eventKey="modelo" active={key === 'modelo'}>
                                    <Suspense fallback={<div>Carregando...</div>}>
                                        {key === 'modelo' && <FormularioModelo />}
                                    </Suspense>
                                </Tab.Pane>
                                <Suspense fallback={<div>Carregando...</div>}>
                                    <Tab.Pane eventKey="produto" active={key === 'produto'}>
                                        {key === 'produto' && <ProducFormList />}
                                    </Tab.Pane>
                                </Suspense>
                            </Tab.Content>
                        </Row>
                    </Container>
                </MainContent>
            </div>
        </div>
    );
};

export default CadastrosIndexEcommerce;
